export default __webpack_public_path__ + "maps-examples-data-driven-symbols-1200-119b794bf625274b74bc645202ecf0ba.webp";